import { redirect } from '@tanstack/react-router';
import { rewriteLegacyIdeaManagementPath } from '@tempo-io/notification-registry';

type IdeaManagementRedirectArgs = {
  params: { org: string; _splat?: string };
  location: { searchStr?: string; hash?: string };
};

export const redirectIdeaManagementToIntake = ({
  params,
  location,
}: IdeaManagementRedirectArgs): never => {
  const remainingPath = params._splat ? `idea-management/${params._splat}` : 'idea-management';
  const searchAndHash = `${location.searchStr ?? ''}${location.hash ? `#${location.hash}` : ''}`;
  throw redirect({
    href: `/org/${params.org}/${rewriteLegacyIdeaManagementPath(remainingPath)}${searchAndHash}`,
    replace: true,
  });
};
